import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faBorderAll,
  faCheckCircle,
  faClock,
  faCreditCard,
  faCog,
  faCopy,
  faEngineWarning,
  faExclamationCircle,
  faFile,
  faFileAlt,
  faFileCertificate,
  faFileExcel,
  faFileInvoice,
  faFilter,
  faFolder,
  faLongArrowDown,
  faPen,
  faPenAlt,
  faSync,
  faUser,
  faUserPlus,
  faVideo,
  faCloudUpload,
  faColumns,
  faTimes,
  faTrash,
  faTimesCircle,
  faThumbsDown,
  faExternalLink,
  faBook,
  faBookOpen,
  faCommentsAlt,
  faLongArrowRight,
  faDatabase,
} from "@fortawesome/pro-light-svg-icons";

export default library.add(
  faBorderAll,
  faCheckCircle,
  faCog,
  faClock,
  faCreditCard,
  faCopy,
  faEngineWarning,
  faExclamationCircle,
  faFile,
  faFileAlt,
  faFileCertificate,
  faFileExcel,
  faFileInvoice,
  faFilter,
  faFolder,
  faLongArrowDown,
  faPen,
  faPenAlt,
  faSync,
  faUser,
  faUserPlus,
  faVideo,
  faCloudUpload,
  faColumns,
  faTimes,
  faTrash,
  faTimesCircle,
  faThumbsDown,
  faExternalLink,
  faBook,
  faBookOpen,
  faCommentsAlt,
  faLongArrowRight,
  faDatabase,
);
